import { useEffect, useState } from 'react';

import { dateToSeconds, fetchExpiryDate } from '../Components/Timer/Timer.helpers';
import { DAYS_TO_EXPIRE_ENQUIRY } from '../valuations.constants';

const useTimeToEnquiryExpire = ({ daysToExpire = DAYS_TO_EXPIRE_ENQUIRY, enquiryDate, vehicle }) => {
  const [enquiryDateStamp, setEnquiryDateStamp] = useState(enquiryDate);
  useEffect(() => setEnquiryDateStamp(enquiryDate), [enquiryDate, vehicle.enquiry]);

  const enquiryExpireDate = fetchExpiryDate({ creationDate: enquiryDateStamp, daysToExpire });
  const secondsToEnquiryExpire = dateToSeconds(enquiryExpireDate);
  const daysToEnquiryExpire = Math.ceil(secondsToEnquiryExpire / 86400); // if less than 24 hours we want to show 1 day

  const [seconds, setSeconds] = useState(secondsToEnquiryExpire);

  useEffect(() => {
    const interval = seconds > 60 ? setInterval(() => setSeconds(seconds - 60), 60000) : null;
    return () => clearInterval(interval);
  }, [seconds]);

  return { days: daysToEnquiryExpire, seconds };
};

export default useTimeToEnquiryExpire;
